// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + {"472":"settings","597":"projects","809":"users","884":"admin"}[chunkId] + "." + {"472":"ed74df1e","597":"21a491de","809":"c2895331","884":"9765690c"}[chunkId] + ".js";
};